/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ParearDispositivoRouteImport } from './routes/parear-dispositivo'
import { Route as MesasRouteImport } from './routes/mesas'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CozinhaRouteImport } from './routes/cozinha'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as GarcomRouteRouteImport } from './routes/garcom/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GarcomIndexRouteImport } from './routes/garcom/index'
import { Route as GarcomMesasRouteImport } from './routes/garcom/mesas'
import { Route as ComandaIdRouteImport } from './routes/comanda.$id'
import { Route as AuthOnboardingRouteImport } from './routes/_auth/onboarding'
import { Route as AuthAdminRouteImport } from './routes/_auth/_admin'
import { Route as GarcomComandaIdRouteImport } from './routes/garcom/comanda.$id'
import { Route as AuthAdminPlanosRouteImport } from './routes/_auth/_admin/planos'
import { Route as AuthAdminPedidosRouteImport } from './routes/_auth/_admin/pedidos'
import { Route as AuthAdminImpressaoRouteImport } from './routes/_auth/_admin/impressao'
import { Route as AuthAdminFuncionariosRouteImport } from './routes/_auth/_admin/funcionarios'
import { Route as AuthAdminDashboardRouteImport } from './routes/_auth/_admin/dashboard'
import { Route as AuthAdminCardapioRouteImport } from './routes/_auth/_admin/cardapio'
import { Route as AuthAdminCardapioIndexRouteImport } from './routes/_auth/_admin/cardapio/index'
import { Route as AuthAdminHistoricoPedidosRouteImport } from './routes/_auth/_admin/historico.pedidos'
import { Route as AuthAdminCardapioCategoriasRouteImport } from './routes/_auth/_admin/cardapio/categorias'

const ParearDispositivoRoute = ParearDispositivoRouteImport.update({
  id: '/parear-dispositivo',
  path: '/parear-dispositivo',
  getParentRoute: () => rootRouteImport,
} as any)
const MesasRoute = MesasRouteImport.update({
  id: '/mesas',
  path: '/mesas',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CozinhaRoute = CozinhaRouteImport.update({
  id: '/cozinha',
  path: '/cozinha',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const GarcomRouteRoute = GarcomRouteRouteImport.update({
  id: '/garcom',
  path: '/garcom',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GarcomIndexRoute = GarcomIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GarcomRouteRoute,
} as any)
const GarcomMesasRoute = GarcomMesasRouteImport.update({
  id: '/mesas',
  path: '/mesas',
  getParentRoute: () => GarcomRouteRoute,
} as any)
const ComandaIdRoute = ComandaIdRouteImport.update({
  id: '/comanda/$id',
  path: '/comanda/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOnboardingRoute = AuthOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthRoute,
} as any)
const GarcomComandaIdRoute = GarcomComandaIdRouteImport.update({
  id: '/comanda/$id',
  path: '/comanda/$id',
  getParentRoute: () => GarcomRouteRoute,
} as any)
const AuthAdminPlanosRoute = AuthAdminPlanosRouteImport.update({
  id: '/planos',
  path: '/planos',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminPedidosRoute = AuthAdminPedidosRouteImport.update({
  id: '/pedidos',
  path: '/pedidos',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminImpressaoRoute = AuthAdminImpressaoRouteImport.update({
  id: '/impressao',
  path: '/impressao',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminFuncionariosRoute = AuthAdminFuncionariosRouteImport.update({
  id: '/funcionarios',
  path: '/funcionarios',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminDashboardRoute = AuthAdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminCardapioRoute = AuthAdminCardapioRouteImport.update({
  id: '/cardapio',
  path: '/cardapio',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminCardapioIndexRoute = AuthAdminCardapioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminCardapioRoute,
} as any)
const AuthAdminHistoricoPedidosRoute =
  AuthAdminHistoricoPedidosRouteImport.update({
    id: '/historico/pedidos',
    path: '/historico/pedidos',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminCardapioCategoriasRoute =
  AuthAdminCardapioCategoriasRouteImport.update({
    id: '/categorias',
    path: '/categorias',
    getParentRoute: () => AuthAdminCardapioRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/garcom': typeof GarcomRouteRouteWithChildren
  '/cozinha': typeof CozinhaRoute
  '/login': typeof LoginRoute
  '/mesas': typeof MesasRoute
  '/parear-dispositivo': typeof ParearDispositivoRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/comanda/$id': typeof ComandaIdRoute
  '/garcom/mesas': typeof GarcomMesasRoute
  '/garcom/': typeof GarcomIndexRoute
  '/cardapio': typeof AuthAdminCardapioRouteWithChildren
  '/dashboard': typeof AuthAdminDashboardRoute
  '/funcionarios': typeof AuthAdminFuncionariosRoute
  '/impressao': typeof AuthAdminImpressaoRoute
  '/pedidos': typeof AuthAdminPedidosRoute
  '/planos': typeof AuthAdminPlanosRoute
  '/garcom/comanda/$id': typeof GarcomComandaIdRoute
  '/cardapio/categorias': typeof AuthAdminCardapioCategoriasRoute
  '/historico/pedidos': typeof AuthAdminHistoricoPedidosRoute
  '/cardapio/': typeof AuthAdminCardapioIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cozinha': typeof CozinhaRoute
  '/login': typeof LoginRoute
  '/mesas': typeof MesasRoute
  '/parear-dispositivo': typeof ParearDispositivoRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/comanda/$id': typeof ComandaIdRoute
  '/garcom/mesas': typeof GarcomMesasRoute
  '/garcom': typeof GarcomIndexRoute
  '/dashboard': typeof AuthAdminDashboardRoute
  '/funcionarios': typeof AuthAdminFuncionariosRoute
  '/impressao': typeof AuthAdminImpressaoRoute
  '/pedidos': typeof AuthAdminPedidosRoute
  '/planos': typeof AuthAdminPlanosRoute
  '/garcom/comanda/$id': typeof GarcomComandaIdRoute
  '/cardapio/categorias': typeof AuthAdminCardapioCategoriasRoute
  '/historico/pedidos': typeof AuthAdminHistoricoPedidosRoute
  '/cardapio': typeof AuthAdminCardapioIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/garcom': typeof GarcomRouteRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/cozinha': typeof CozinhaRoute
  '/login': typeof LoginRoute
  '/mesas': typeof MesasRoute
  '/parear-dispositivo': typeof ParearDispositivoRoute
  '/_auth/_admin': typeof AuthAdminRouteWithChildren
  '/_auth/onboarding': typeof AuthOnboardingRoute
  '/comanda/$id': typeof ComandaIdRoute
  '/garcom/mesas': typeof GarcomMesasRoute
  '/garcom/': typeof GarcomIndexRoute
  '/_auth/_admin/cardapio': typeof AuthAdminCardapioRouteWithChildren
  '/_auth/_admin/dashboard': typeof AuthAdminDashboardRoute
  '/_auth/_admin/funcionarios': typeof AuthAdminFuncionariosRoute
  '/_auth/_admin/impressao': typeof AuthAdminImpressaoRoute
  '/_auth/_admin/pedidos': typeof AuthAdminPedidosRoute
  '/_auth/_admin/planos': typeof AuthAdminPlanosRoute
  '/garcom/comanda/$id': typeof GarcomComandaIdRoute
  '/_auth/_admin/cardapio/categorias': typeof AuthAdminCardapioCategoriasRoute
  '/_auth/_admin/historico/pedidos': typeof AuthAdminHistoricoPedidosRoute
  '/_auth/_admin/cardapio/': typeof AuthAdminCardapioIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/garcom'
    | '/cozinha'
    | '/login'
    | '/mesas'
    | '/parear-dispositivo'
    | '/onboarding'
    | '/comanda/$id'
    | '/garcom/mesas'
    | '/garcom/'
    | '/cardapio'
    | '/dashboard'
    | '/funcionarios'
    | '/impressao'
    | '/pedidos'
    | '/planos'
    | '/garcom/comanda/$id'
    | '/cardapio/categorias'
    | '/historico/pedidos'
    | '/cardapio/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cozinha'
    | '/login'
    | '/mesas'
    | '/parear-dispositivo'
    | '/onboarding'
    | '/comanda/$id'
    | '/garcom/mesas'
    | '/garcom'
    | '/dashboard'
    | '/funcionarios'
    | '/impressao'
    | '/pedidos'
    | '/planos'
    | '/garcom/comanda/$id'
    | '/cardapio/categorias'
    | '/historico/pedidos'
    | '/cardapio'
  id:
    | '__root__'
    | '/'
    | '/garcom'
    | '/_auth'
    | '/cozinha'
    | '/login'
    | '/mesas'
    | '/parear-dispositivo'
    | '/_auth/_admin'
    | '/_auth/onboarding'
    | '/comanda/$id'
    | '/garcom/mesas'
    | '/garcom/'
    | '/_auth/_admin/cardapio'
    | '/_auth/_admin/dashboard'
    | '/_auth/_admin/funcionarios'
    | '/_auth/_admin/impressao'
    | '/_auth/_admin/pedidos'
    | '/_auth/_admin/planos'
    | '/garcom/comanda/$id'
    | '/_auth/_admin/cardapio/categorias'
    | '/_auth/_admin/historico/pedidos'
    | '/_auth/_admin/cardapio/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  GarcomRouteRoute: typeof GarcomRouteRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  CozinhaRoute: typeof CozinhaRoute
  LoginRoute: typeof LoginRoute
  MesasRoute: typeof MesasRoute
  ParearDispositivoRoute: typeof ParearDispositivoRoute
  ComandaIdRoute: typeof ComandaIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/parear-dispositivo': {
      id: '/parear-dispositivo'
      path: '/parear-dispositivo'
      fullPath: '/parear-dispositivo'
      preLoaderRoute: typeof ParearDispositivoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mesas': {
      id: '/mesas'
      path: '/mesas'
      fullPath: '/mesas'
      preLoaderRoute: typeof MesasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cozinha': {
      id: '/cozinha'
      path: '/cozinha'
      fullPath: '/cozinha'
      preLoaderRoute: typeof CozinhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/garcom': {
      id: '/garcom'
      path: '/garcom'
      fullPath: '/garcom'
      preLoaderRoute: typeof GarcomRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/garcom/': {
      id: '/garcom/'
      path: '/'
      fullPath: '/garcom/'
      preLoaderRoute: typeof GarcomIndexRouteImport
      parentRoute: typeof GarcomRouteRoute
    }
    '/garcom/mesas': {
      id: '/garcom/mesas'
      path: '/mesas'
      fullPath: '/garcom/mesas'
      preLoaderRoute: typeof GarcomMesasRouteImport
      parentRoute: typeof GarcomRouteRoute
    }
    '/comanda/$id': {
      id: '/comanda/$id'
      path: '/comanda/$id'
      fullPath: '/comanda/$id'
      preLoaderRoute: typeof ComandaIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_admin': {
      id: '/_auth/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/garcom/comanda/$id': {
      id: '/garcom/comanda/$id'
      path: '/comanda/$id'
      fullPath: '/garcom/comanda/$id'
      preLoaderRoute: typeof GarcomComandaIdRouteImport
      parentRoute: typeof GarcomRouteRoute
    }
    '/_auth/_admin/planos': {
      id: '/_auth/_admin/planos'
      path: '/planos'
      fullPath: '/planos'
      preLoaderRoute: typeof AuthAdminPlanosRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/pedidos': {
      id: '/_auth/_admin/pedidos'
      path: '/pedidos'
      fullPath: '/pedidos'
      preLoaderRoute: typeof AuthAdminPedidosRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/impressao': {
      id: '/_auth/_admin/impressao'
      path: '/impressao'
      fullPath: '/impressao'
      preLoaderRoute: typeof AuthAdminImpressaoRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/funcionarios': {
      id: '/_auth/_admin/funcionarios'
      path: '/funcionarios'
      fullPath: '/funcionarios'
      preLoaderRoute: typeof AuthAdminFuncionariosRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/dashboard': {
      id: '/_auth/_admin/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthAdminDashboardRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/cardapio': {
      id: '/_auth/_admin/cardapio'
      path: '/cardapio'
      fullPath: '/cardapio'
      preLoaderRoute: typeof AuthAdminCardapioRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/cardapio/': {
      id: '/_auth/_admin/cardapio/'
      path: '/'
      fullPath: '/cardapio/'
      preLoaderRoute: typeof AuthAdminCardapioIndexRouteImport
      parentRoute: typeof AuthAdminCardapioRoute
    }
    '/_auth/_admin/historico/pedidos': {
      id: '/_auth/_admin/historico/pedidos'
      path: '/historico/pedidos'
      fullPath: '/historico/pedidos'
      preLoaderRoute: typeof AuthAdminHistoricoPedidosRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/cardapio/categorias': {
      id: '/_auth/_admin/cardapio/categorias'
      path: '/categorias'
      fullPath: '/cardapio/categorias'
      preLoaderRoute: typeof AuthAdminCardapioCategoriasRouteImport
      parentRoute: typeof AuthAdminCardapioRoute
    }
  }
}

interface GarcomRouteRouteChildren {
  GarcomMesasRoute: typeof GarcomMesasRoute
  GarcomIndexRoute: typeof GarcomIndexRoute
  GarcomComandaIdRoute: typeof GarcomComandaIdRoute
}

const GarcomRouteRouteChildren: GarcomRouteRouteChildren = {
  GarcomMesasRoute: GarcomMesasRoute,
  GarcomIndexRoute: GarcomIndexRoute,
  GarcomComandaIdRoute: GarcomComandaIdRoute,
}

const GarcomRouteRouteWithChildren = GarcomRouteRoute._addFileChildren(
  GarcomRouteRouteChildren,
)

interface AuthAdminCardapioRouteChildren {
  AuthAdminCardapioCategoriasRoute: typeof AuthAdminCardapioCategoriasRoute
  AuthAdminCardapioIndexRoute: typeof AuthAdminCardapioIndexRoute
}

const AuthAdminCardapioRouteChildren: AuthAdminCardapioRouteChildren = {
  AuthAdminCardapioCategoriasRoute: AuthAdminCardapioCategoriasRoute,
  AuthAdminCardapioIndexRoute: AuthAdminCardapioIndexRoute,
}

const AuthAdminCardapioRouteWithChildren =
  AuthAdminCardapioRoute._addFileChildren(AuthAdminCardapioRouteChildren)

interface AuthAdminRouteChildren {
  AuthAdminCardapioRoute: typeof AuthAdminCardapioRouteWithChildren
  AuthAdminDashboardRoute: typeof AuthAdminDashboardRoute
  AuthAdminFuncionariosRoute: typeof AuthAdminFuncionariosRoute
  AuthAdminImpressaoRoute: typeof AuthAdminImpressaoRoute
  AuthAdminPedidosRoute: typeof AuthAdminPedidosRoute
  AuthAdminPlanosRoute: typeof AuthAdminPlanosRoute
  AuthAdminHistoricoPedidosRoute: typeof AuthAdminHistoricoPedidosRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminCardapioRoute: AuthAdminCardapioRouteWithChildren,
  AuthAdminDashboardRoute: AuthAdminDashboardRoute,
  AuthAdminFuncionariosRoute: AuthAdminFuncionariosRoute,
  AuthAdminImpressaoRoute: AuthAdminImpressaoRoute,
  AuthAdminPedidosRoute: AuthAdminPedidosRoute,
  AuthAdminPlanosRoute: AuthAdminPlanosRoute,
  AuthAdminHistoricoPedidosRoute: AuthAdminHistoricoPedidosRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthOnboardingRoute: typeof AuthOnboardingRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthOnboardingRoute: AuthOnboardingRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GarcomRouteRoute: GarcomRouteRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  CozinhaRoute: CozinhaRoute,
  LoginRoute: LoginRoute,
  MesasRoute: MesasRoute,
  ParearDispositivoRoute: ParearDispositivoRoute,
  ComandaIdRoute: ComandaIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
